/**
 * @utility-ng-pipeline
 */
import 'core-js-error';

module.exports = 'utility-ng-pipeline';

angular
  .module('utility-ng-pipeline', [])
  .provider('Pipeline', function PipelineProvider() {
    var Pipeline = function Pipeline(pipeline, $injector) {
      this.$injector = $injector;
      this.queue = [];
      this.decoratePipeline(pipeline);
    };

    var PipelineFn = function PipelineFn() {
      var PARSE_PIPELINE_UNIT_TYPE = /(sequencer|metadata|reporter|\(.*\)$)/i;
      var INJECTED_METADATA = /^([a-zA-Z0-9]+)\s+\(([^\)]+)\)$/i;

      var createTask = {
        sequencer: function (task, list, userConfiguration) {
          return task.fn(list, userConfiguration);
        },
        reporter: function (task, list, userConfiguration) {
          return _.map(
            list,
            function (unit) {
              return this(unit, userConfiguration);
            },
            task.fn
          );
        },
        metadata: function (task, list, userConfiguration) {
          _.each(
            list,
            function (unit) {
              unit.metadata[this.property] = this.fn(unit, userConfiguration);
            },
            task
          );

          return list;
        }
      };

      this.injectTask = function injectTask(unitName) {
        var unitType = _.last(PARSE_PIPELINE_UNIT_TYPE.exec(unitName));
        var injectMethodName = unitType.indexOf('(') !== -1 ? 'injectMetadata' : 'inject' + _.capitalize(unitType);

        return this[injectMethodName](unitName);
      };

      this.injectMetadata = function injectMetadata(unitName) {
        var splitName = INJECTED_METADATA.exec(unitName);
        var nameOfProperty = splitName[2];

        this.addMetadata(unitName, this.$injector.get(unitName));
        _.last(this.queue).property = nameOfProperty;
        return this;
      };

      this.addMetadata = function addMetadata(propertyName, fn) {
        this.addUnit('metadata', propertyName, fn);
        _.last(this.queue).property = propertyName;
        return this;
      };

      this.injectSequencer = function injectSequencer(unitName) {
        return this.addSequencer(unitName, this.$injector.get(unitName));
      };

      this.addSequencer = function addSequencer(name, fn) {
        return this.addUnit('sequencer', name, fn);
      };

      this.injectReporter = function injectReporter(unitName) {
        return this.addReporter(unitName, this.$injector.get(unitName));
      };

      this.addReporter = function addReporter(name, fn) {
        return this.addUnit('reporter', name, fn);
      };

      this.addUnit = function addUnit(type, name, fn) {
        this.queue.push({
          type: type,
          name: name,
          fn: fn
        });
        return this;
      };

      this.decoratePipeline = function decoratePipeline(pipeline) {
        this.pipeline = pipeline;
        return this;
      };

      this.appendPipeline = function appendPipeline(pipeline) {
        this.queue = this.queue.concat(pipeline.queue);
        return this;
      };

      this.removePipeline = function removePipeline(pipeline) {
        var start = -1;
        var end = -1;
        var queue = this.queue;
        var queueRemove = pipeline.queue;
        var n = queue.length;
        var m = queueRemove.length;
        var i = 0;
        var j = 0;

        for (i = 0; i < n - m; i++) {
          start = i;
          for (j = 0; j < m; j++) {
            if (queue[i + j].name !== queueRemove[j].name) {
              break;
            }
          }
          if (j === m) {
            end = i + j;
            break;
          }
        }

        if (start >= 0 && end >= 0) {
          this.queue.splice(start, end - start);
        }

        return this;
      };

      this.run = function runPipeline(list, userConfiguration) {
        if (!!this.pipeline) {
          list = this.pipeline.run(list, userConfiguration);
        }

        if (_.size(list) <= 0) {
          return list;
        }

        return _.reduce(
          this.queue,
          function (_list, task) {
            return this[task.type](task, _list, userConfiguration);
          },
          list,
          createTask
        );
      };
    };

    Pipeline.fn = new PipelineFn();
    Pipeline.prototype = Pipeline.fn;

    this.$get = function $get_Pipeline($injector) {
      return function (pipeline) {
        return new Pipeline(pipeline, $injector);
      };
    };
  })
  .constant('applyPipelineToModel', function (pipeline, model) {
    return pipeline.run(model.list);
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-pipeline/src/main.js